import { computed, Ref, SetupContext } from '@vue/composition-api';
import { ButtonNavButton } from '@front-app/components/buttons/buttonNav';
import { get, MaybeRef } from '@vueuse/shared';

export interface UseTabbedNav {
	tabButtons: Ref<ButtonNavButton[]>;
	currentTabKey: Ref<string | null>;
}

export const useTabbedNav = (
	ctx: SetupContext,
	tabs: MaybeRef<ButtonNavButton[]>,
	routeToTab: {[key: string]: string},
): UseTabbedNav => {
	const tabButtons = computed(() => get(tabs).map((item) => ({
		...item,
		label: ctx.root.$t(item.label) as unknown as string,
	})));

	function isNotUndefined<T>(x: T | undefined): x is T {
		return x !== undefined;
	}

	const currentTabKey = computed(() => {
		const matchedRouteNames = ctx.root.$route.matched
			.map(({ name }) => name)
			.filter(isNotUndefined)
			.map((name) => routeToTab[name])
			.filter(Boolean);
		return matchedRouteNames.length > 0 ? matchedRouteNames[0] : null;
	});

	return {
		tabButtons,
		currentTabKey,
	};
};
